import React, {useEffect} from 'react';
import {SELFIE_STATE, useSelfieUploadState} from "../selfie_context";
import {readFileAsDataURL} from "../utils";
import useTranslation from "../../virtual_congress/effects/use_translation";

const PreviewContent = () => {
  const {
    mode,
    file,
    targetWidth,
    targetHeight,
  } = useSelfieUploadState()
  const [fileUrl, setFileUrl] = React.useState(null)


  useEffect(() => {
    readFileAsDataURL(file)
      .then((url) => {
        setFileUrl(url)
      })
  }, [file]);

  if (!fileUrl) {
    return null
  }

  switch (mode) {
    case "video":
      return <video
        controls={true}
        className="w-100 selfie-preview-video"
        width={targetWidth}
        height={targetHeight}
        autoPlay={true}
        loop={true}
        playsInline={true}
        src={fileUrl}>
      </video>
    case "image":
      return <img className={"img-fluid selfie-preview-image"} src={fileUrl}/>
    default:
      throw new Error(`Unknown mode: ${mode}`)
  }
}

export const Preview = () => {
  const translation = useTranslation()
  const {setState, setFile} = useSelfieUploadState()

  const handleClickConfirm = () => {
    setState(SELFIE_STATE.UPLOAD)
  }

  const handleClickRetake = () => {
    setFile(null)
    setState(SELFIE_STATE.MEDIA_INPUT)
  }

  return <>
    <PreviewContent/>
    <div className="d-grid selfie-preview-button-container">
      <button className="btn btn-light my-2 selfie-preview-retake-button" onClick={handleClickRetake}>
        {translation("selfie_upload.preview_retake", {}, "Retry")}
      </button>
      <button className="btn btn-success my-2 selfie-preview-confirm-button" onClick={handleClickConfirm}>
        {translation("selfie_upload.preview_confirm", {}, "Upload")}
      </button>
    </div>
  </>
}